.form {
  display: grid;
  gap: 16px;
}

.field {
  display: grid;
  gap: 6px;
}

.label {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.input {
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--color-border);
  background: rgb(0 0 0 / 0.25);
  font-size: 1.05rem;
}

.input:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 4px rgb(232 184 79 / 0.18);
}

.codeInput {
  font-family: ui-monospace, 'Cascadia Code', Menlo, monospace;
  font-size: 1.8rem;
  letter-spacing: 0.25em;
  text-align: center;
  text-transform: uppercase;
}

.codeInput::placeholder {
  color: rgb(255 255 255 / 0.18);
}

.hint {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.buttons {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.error {
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-small);
  background: rgb(239 91 91 / 0.12);
  color: #ffb4b4;
  font-size: 0.9rem;
}
